'use strict';

/**
 * cms index module
 */
require(['vue', 'homeApp', 'vueInfiniteScroll', 'vueLazyload', 'fastClick', 'validate', 'modal', 'polyfill', 'es6PromiseAuto'], function (Vue, homeApp, vueInfiniteScroll, vueLazyload, fastClick, validate, VModal) {
  /* eslint no-new: "off" */
  Vue.config.productionTip = false;
  Vue.use(vueInfiniteScroll);
  Vue.use(vueLazyload, {
    preLoad: 1.3,
    loading: require.toUrl('images/spinner.svg'),
    attempt: 1
  });
  if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {
      fastClick.attach(document.body);
    }, false);
  }
  Vue.use(validate, {
    locale: 'en',
    events: ''
  });
  // 使用modal
  Vue.use(VModal.default, { componentName: 'modal' });
  // 实例化vue
  new Vue({
    el: '#app',
    template: '<homeApp/>',
    components: {
      homeApp: homeApp
    }
  });
});
define("Magento_Cms/modules/cms_index", function(){});

